import React from "react";
import styled from "styled-components";

import { Heading } from "../components/Heading";
import { CrossIcon } from "../components/icons/CustomIcons";
import { TestSelectors } from "../util/testSelectors";

import { Flex } from "./Flex";
import { HexButton } from "./HexButton";
import { Txt } from "./Txt";

type HexDialogHeaderProps = {
  title: React.ReactNode;
  onClose?: () => void;
  subtitle?: React.ReactNode;
  className?: string;
};

export const HexDialogHeader = React.memo(function HexDialogHeader({
  className,
  onClose,
  subtitle,
  title,
}: HexDialogHeaderProps) {
  return (
    <HeaderFlex align="start" className={className} gap={8} justify="between">
      <Flex direction="column" gap={4}>
        <Heading renderAs="h4">{title}</Heading>
        {subtitle && (
          <Txt fontColor="muted" fontSize="small">
            {subtitle}
          </Txt>
        )}
      </Flex>
      {onClose && (
        <HexButton
          data-test={TestSelectors.DIALOG_CLOSE_BUTTON}
          icon={<CrossIcon />}
          minimal={true}
          small={true}
          onClick={onClose}
        />
      )}
    </HeaderFlex>
  );
});

const HeaderFlex = styled(Flex)`
  padding: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor.MUTED};
`;
